'use client';

import classNames from 'classnames';
import { useState } from 'react';

import { slugify } from '@/util/strings/slugify';

import type { Section as SectionType } from '../types';

import { Section } from './Section';

import styles from './GenericTable.module.scss';

interface Props {
    columns: string[];
    sections: SectionType[];
}

export function GenericTable({ columns, sections }: Props) {
    const [selectedColumn, setSelectedColumn] = useState<string>();

    return (
        <div data-generic-table className={styles.table}>
            <div className={classNames(styles.columns, styles['columns--mobile'])}>
                {columns.map((column) => (
                    <button
                        key={column}
                        className={classNames(styles.column, {
                            [styles['column--unselected']]: selectedColumn !== column,
                        })}
                        onClick={() => setSelectedColumn(column)}
                    >
                        {column}
                    </button>
                ))}
            </div>
            {sections.map((section) => (
                <Section
                    data-table-section={slugify(section.title)}
                    key={section.title}
                    columns={columns}
                    section={section}
                    selectedColumn={selectedColumn}
                />
            ))}
        </div>
    );
}
